module.exports = __webpack_public_path__ + "img/SelectIcon.efaff538.png";